import { css } from 'styled-components';

export const everydayGradient = css`
    ${({ theme }) =>
        `background: linear-gradient(0, ${theme.colorSystem.gradients[6][0]}, ${theme.colorSystem.gradients[6][1]});
    `}
`;

export const smartGradient = css`
    ${({ theme }) =>
        `background: linear-gradient(180deg, ${theme.colorSystem.gradients[7][0]}, ${theme.colorSystem.gradients[7][1]});
    `}
`;

export const smartPlusGradient = css`
    ${({ theme }) =>
        `background: linear-gradient(355deg, ${theme.colorSystem.gradients[8][0]} 29.59%, ${theme.colorSystem.gradients[8][1]} 67.67%);
    `}
`;

const white = css`
    ${({ theme }) =>
        `background-color: ${theme.colorSystem.primary[3]};
    `}
`;

const grey = css`
    ${({ theme }) =>
        `background-color: ${theme.colorSystem.UIElements[5]};
         box-shadow: none;
    `}
`;

const cardBackground = {
    everyday_gradient: everydayGradient,
    smart_gradient: smartGradient,
    smart_plus_gradient: smartPlusGradient,
    white,
    grey
};

const cardBackgroundOption = css`
    ${({ cardBackgroundColor }) => cardBackground[cardBackgroundColor]}
`;

export default cardBackgroundOption;
